import { Select, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import { toast } from "react-toastify";
import {
  useGetMemberCompaniesQuery,
  useAssignMemberCompaniesMutation,
  useUnassignMemberCompanyMutation,
  useGetSpecificMemberQuery,
} from "../../../Redux/service/Teams/Teams";
import { useGetAllCompaniesQuery } from "../../../Redux/service/Companies/Company";

export default function AssignCompanyPopup({ setEdited }) {
  const {
    isAssigningCompany,
    setIsAssigningCompany,
    activeUserForCompany,
  } = useContext(popupcontext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [companies, setCompanies] = useState([]);

  const memberId = activeUserForCompany?.id;

  const { data: memberCompaniesData } = useGetMemberCompaniesQuery(memberId, {
    skip: !memberId || !isAssigningCompany,
    refetchOnMountOrArgChange: true,
  });

  const { data: allCompaniesData } = useGetAllCompaniesQuery(
    {
      page: 1,
      limit: 10000,
      search: "",
    },
    { skip: !isAssigningCompany, refetchOnMountOrArgChange: true }
  );

  const { data: memberData } = useGetSpecificMemberQuery(memberId, {
    skip: !memberId,
  });

  const [assignMemberCompanies] = useAssignMemberCompaniesMutation();
  const [unassignMemberCompany] = useUnassignMemberCompanyMutation();

  const handleDropdownVisibleChange = (visible) => {
    setIsOpen(!!visible);
  };

  // Set selected companies from GET /members/memberId/companies
  useEffect(() => {
    if (!memberId || !isAssigningCompany) return;
    const list = memberCompaniesData?.data;
    if (Array.isArray(list)) {
      const ids = list.map((item) =>
        typeof item === "object" && item !== null && "companyId" in item
          ? item.companyId
          : item.id ?? item
      );
      setSelectedCompanies(ids);
    } else if (list && typeof list === "object" && !Array.isArray(list)) {
      const arr = list.companies ?? list.data ?? [];
      setSelectedCompanies(arr.map((c) => c.companyId ?? c.id ?? c));
    } else {
      setSelectedCompanies([]);
    }
  }, [memberCompaniesData?.data, memberId, isAssigningCompany]);

  // Set company options from all companies
  useEffect(() => {
    if (allCompaniesData?.data) {
      setCompanies(
        allCompaniesData.data.map((company) => ({
          value: company.id,
          label: company.name || company.companyName || `Company ${company.id}`,
        }))
      );
    }
  }, [allCompaniesData?.data]);

  const handleAssign = async (companyId) => {
    if (!memberId) return;
    try {
      await assignMemberCompanies({
        memberId,
        payload: { companyId: [companyId], notes: "" },
      }).unwrap();
      toast.success(trans("User assigned to company successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
      setEdited?.();
    } catch (error) {
      setSelectedCompanies((prev) => prev.filter((v) => v !== companyId));
      toast.error(
        error?.data?.message || trans("Failed to assign user to company"),
        {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar",
        }
      );
    }
  };

  const handleUnAssign = async (companyId) => {
    if (!memberId) return;
    try {
      await unassignMemberCompany({ memberId, companyId }).unwrap();
      toast.success(trans("User unassigned from company successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
      setSelectedCompanies((prev) => prev.filter((v) => v !== companyId));
      setEdited?.();
    } catch (error) {
      toast.error(
        error?.data?.message || trans("Failed to unassign user from company"),
        {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar",
        }
      );
    }
  };

  useEffect(() => {
    if (!isAssigningCompany) {
      setSelectedCompanies([]);
    }
  }, [isAssigningCompany]);

  const memberName = memberData?.data?.name || memberData?.data?.email || "";

  return (
    <Popup show={isAssigningCompany} size="lg" style={"popup-bodyscroll"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={trans("Assign Companies")}
            subtitle={memberName}
          />
        </Modal.Title>
        <Close
          style="close-32 close"
          close={() => {
            setIsAssigningCompany(false);
          }}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <div>
          <div className="mult-input-label">{trans("Companies")}</div>
          <Space
            style={{
              width: "100%",
            }}
            direction="vertical"
          >
            <Select
              mode="multiple"
              style={{
                width: "100%",
                marginTop: "8px",
              }}
              maxTagCount={"responsive"}
              placeholder={trans("Please select companies")}
              onSelect={(value) => {
                setSelectedCompanies((prev) => [...prev, value]);
                handleAssign(value);
              }}
              onDeselect={(value) => {
                setSelectedCompanies((prev) => prev.filter((v) => v !== value));
                handleUnAssign(value);
              }}
              value={selectedCompanies}
              options={companies}
              open={isOpen}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Space>
        </div>
      </Modal.Body>
    </Popup>
  );
}
